import { importWithRetry } from '@trello/use-lazy-component';

export const boardViewViewLoaders = {
  loadCalendarControllerView: () =>
    importWithRetry(() =>
      import(
        /* webpackChunkName: "calendar-controller-view" */ 'app/scripts/views/calendar/calendar-controller-view.coffee'
      ),
    ).then((m) => m.default),

  loadMapView: () =>
    importWithRetry(() =>
      import(
        /* webpackChunkName: "map-view" */ 'app/scripts/views/map/map-view.coffee'
      ),
    ).then((m) => m.default),

  loadButlerView: () =>
    importWithRetry(() =>
      import(
        /* webpackChunkName: "butler-view" */ 'app/scripts/views/butler/butler-view.coffee'
      ),
    ).then((m) => m.default),
};
